import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0287023c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lbfanghu-container" }
const _hoisted_2 = { class: "nav-bg" }
const _hoisted_3 = { class: "card-float" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总预警次数", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本月预警次数", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_8 = { class: "list-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编号：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "电量：", -1))
const _hoisted_12 = {
  key: 0,
  class: "bottom-text"
}
const _hoisted_13 = {
  key: 1,
  class: "bottom-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.count.alarmNum ? _ctx.count.alarmNum : 0), 1),
              _hoisted_5
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.count.alarmMonthNum ? _ctx.count.alarmMonthNum : 0), 1),
              _hoisted_7
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "listdata",
              onClick: ($event: any) => (_ctx.lbDetail(item))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(item.deviceName), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(item.deviceSn), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createVNode(_component_van_progress, {
                    color: item.power > 30 ? '#1EE484' : '#FF966E',
                    percentage: item.power,
                    "show-pivot": false,
                    "stroke-width": "10"
                  }, null, 8, ["color", "percentage"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString((item.power ? item.power : 0) + "%"), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_9))
          }), 128)),
          (_ctx.list.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "到底了~~"))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无数据"))
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ]))
}